import { OptionalNullableBooleanSchema } from '../../../valibot/schema/OptionalNullableBoolean.type'
import { literal, object, type InferOutput } from "valibot"
import { InputBindingDevice } from "../InputBindingDevice.enum"
import { KeyCodeSchema } from '../KeyCode.type'

export const KeyboardInputBindingSchema = object({
  device: literal(InputBindingDevice.Keyboard),
  code: KeyCodeSchema,
  shift: OptionalNullableBooleanSchema,
  ctrl: OptionalNullableBooleanSchema,
  alt: OptionalNullableBooleanSchema,
})

export type KeyboardInputBinding = InferOutput<typeof KeyboardInputBindingSchema>
